import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import { colors } from '../../../styles/theme';
import { RECORD_VIEW_MODES } from '../../utils/recordViewMode';

const OPTIONS = [
  { mode: RECORD_VIEW_MODES.LIST, label: 'Una card por registro', Icon: ViewAgendaOutlinedIcon },
  { mode: RECORD_VIEW_MODES.GRID, label: 'Dos cards por fila', Icon: GridViewOutlinedIcon, gridOnly: true },
  { mode: RECORD_VIEW_MODES.GROUPED, label: 'Agrupar por lote', Icon: AccountTreeOutlinedIcon },
];

/**
 * Selector de vista de Registros / detalle de lista. Mismo control segmentado
 * que el toggle lista/grilla del share (`SharedListPage`), a la derecha de
 * «Ordenar por:». La grilla solo aparece si el ancho la permite.
 */
export default function RecordViewModeToggle({ value, onChange, canUseGrid = true }) {
  return (
    <Box
      role="group"
      aria-label="Vista de registros"
      data-testid="record-view-mode-toggle"
      sx={{
        display: 'flex',
        gap: '2px',
        p: '2px',
        borderRadius: '8px',
        bgcolor: 'rgba(255,255,255,0.06)',
        flexShrink: 0,
      }}
    >
      {OPTIONS.filter((option) => canUseGrid || !option.gridOnly).map(({ mode, label, Icon }) => {
        const active = value === mode;
        return (
          <Tooltip key={mode} title={label} placement="bottom" arrow>
            <IconButton
              size="small"
              onClick={() => onChange?.(mode)}
              aria-label={label}
              aria-pressed={active}
              sx={{
                p: '4px',
                borderRadius: '6px',
                color: active ? colors.primary : colors.textPanelTitle,
                bgcolor: active ? 'rgba(255,255,255,0.10)' : 'transparent',
                '&:hover': {
                  color: active ? colors.primary : colors.textPrimary,
                  bgcolor: 'rgba(255,255,255,0.12)',
                },
              }}
            >
              <Icon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        );
      })}
    </Box>
  );
}
